<div>
	<app-portfolio [widget]="widget()" />
</div>
